module.exports = __webpack_public_path__ + "img/4.41d7690d.webp";